import React from 'react';
import ApartmentsListError from './apartmentsListError';
import NoApartmentsFound from './noApartmentsFound';
import ApartmentBox from '../apartmentBox';
import ApartmentBoxLoader from '../apartmentBox/apartmentBoxLoader';
import {
	Columns, Column
} from '../base';
import * as StyledApartmentsList from './apartmentList.styles';

const ApartmentsList = ({
	apartments,
	error,
	loading
}) => {
	return (
		<div>
			{
				error && <ApartmentsListError />
			}
			<Columns>
				{
					loading && !error && [...Array(10)].map((value, index) => (
						<StyledApartmentsList.AnimatedColumn
							tablet={1 / 2}
							desktopSmall={1 / 3}
							desktopLarge={1 / 4}
							key={index}>
							<ApartmentBoxLoader />
						</StyledApartmentsList.AnimatedColumn>
					))
				}
				{
					!loading && !error && apartments && apartments.length === 0 && (
						<Column>
							<NoApartmentsFound />
						</Column>
					)
				}
				{
					!loading && !error && apartments && apartments.map(apartment => (
						<StyledApartmentsList.AnimatedColumn
							tablet={1 / 2}
							desktopSmall={1 / 3}
							desktopLarge={1 / 4}
							key={apartment.Id}>
							<ApartmentBox apartment={apartment} />
						</StyledApartmentsList.AnimatedColumn>
					))
				}
			</Columns>
		</div>
	);
};

export default ApartmentsList;
